const botReducer = (state= {trigger: false}, action) => {
    switch (action.type){
        case 'UPDATED_LIST_OF_BOTS':
            const new_trigger = !state.trigger
            return {...state, trigger: new_trigger}
        default:
            return state;
    }
}
export default botReducer;